import { render, staticRenderFns } from "./MonthlySummary.vue?vue&type=template&id=60a510ef&"
import script from "./MonthlySummary.vue?vue&type=script&lang=js&"
export * from "./MonthlySummary.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports